const parentProfileConfig = [
  {
    label: 'Contact',
    hidden: false,
    sectionItems: [
      {
        label: "Guardian's First Name",
        dataKey: 'parentFirstName',
        hidden: false,
      },
      {
        label: "Guardian's Last Name",
        dataKey: 'parentLastName',
        hidden: false,
      },
      {
        label: "Guardian's Email",
        dataKey: 'parentEmail',
        hidden: false,
      },
      {
        label: "Guardian's Phone Number",
        dataKey: 'parentPhone',
        hidden: false,
      },
      {
        label: "Prospect's First Name",
        dataKey: 'firstName',
        hidden: false,
      },
      {
        label: "Prospect's Last Name",
        dataKey: 'lastName',
        hidden: false,
      },
      {
        label: "Prospect's Email",
        dataKey: 'email',
        hidden: false,
      },
      {
        label: "Prospect's Phone Number",
        dataKey: 'phoneNumber',
        hidden: false,
      },
    ],
  },
  {
    label: 'Location',
    hidden: false,
    sectionItems: [
      {
        label: 'Country',
        dataKey: 'country',
        hidden: false,
      },
      {
        label: 'State',
        dataKey: 'state',
        hidden: false,
      },
      {
        label: 'City',
        dataKey: 'city',
        hidden: false,
      },
      {
        label: 'Postal Code',
        dataKey: 'postalCode',
        hidden: false,
      },
    ],
  },
  {
    label: 'Demographic',
    hidden: false,
    sectionItems: [
      {
        label: 'Date of Birth',
        dataKey: 'dateOfBirth',
        hidden: false,
      },
      {
        label: 'Gender',
        dataKey: 'gender',
        hidden: false,
      },
      {
        label: 'Ethnicity',
        dataKey: 'ethnicity',
        hidden: false,
      },
    ],
  },
  {
    label: 'Academic',
    hidden: false,
    sectionItems: [
      {
        label: 'Intended Level of Study',
        dataKey: 'levelOfStudy',
        hidden: false,
      },
      {
        label: 'Intended Entry Term',
        dataKey: ['intendedEntryTerm', 'intendedEntryYear'],
        hidden: false,
      },
      {
        label: 'Intended Major',
        dataKey: 'intendedMajor',
        hidden: false,
      },
      {
        label: 'Current/Recent School',
        dataKey: 'currentSchool',
        hidden: false,
      },
      {
        label: 'Date Registered',
        dataKey: 'dateRegistered',
        hidden: false,
      },
      {
        label: 'Location Registered',
        dataKey: 'locationName',
        hidden: false,
      },
      {
        label: 'Personalization Preferences',
        dataKey: 'personalizationPreferences',
        hidden: false,
      },
      {
        label: 'Personalization Suggestions',
        dataKey: 'personalizationSuggestions',
        hidden: false,
      },
    ],
  },
  {
    label: 'Score',
    hidden: false,
    sectionItems: [
      {
        label: 'SAT',
        dataKey: 'sat',
        hidden: false,
      },
      {
        label: 'ACT',
        dataKey: 'act',
        hidden: false,
      },
      {
        label: 'GPA (u/w)',
        dataKey: 'unweightedGPA',
        hidden: false,
      },
    ],
  },
];

export { parentProfileConfig };
